import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import {
  Box,
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  Switch,
} from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../components/MaterialInput";
import MaterialBox from "../../components/MaterialBox";
import MaterialButton from "../../components/MaterialButton";
import { useLocation, useNavigate } from "react-router-dom";
import { BsFillPersonBadgeFill } from "react-icons/bs";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import { AddUomMutation } from "../../lib/graphQL/graphMutation";
import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import MaterialSelect from "../../components/MasterSelect";
import { unitData } from "./uomData";
import { getUom } from "../../lib/graphQL/graphQuery";
import {
  delteUomService,
  updateUomService,
} from "../../lib/appUtliz/UomService";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useLoading } from "../../context/LodingContext";
import { useError } from "../../context/ErrorContext";
import { useSuccess } from "../../context/SucccessContext";

export default function AddUom() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const params = useLocation();
  const id = params.search.slice(1);
  const [selectedData, setSelectedData] = useState([]);
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus, errormessage, setErrormessage } = useError();
  const [pendingLoading, setPendingLoading] = useState(false);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });
  const [uomData, setUomData] = useState({
    // Uom Details
    uomName: "",
    uomAbbreviation: "",
    decimalPlaces: "",
    baseUnitValue: "",
    baseUnit: "",
    status: true,

    // Uom Type Status
    uomNameStatus: "unchecked",
    uomAbbreviationStatus: "unchecked",
    decimalPlacesStatus: "unchecked",
    baseUnitValueStatus: "unchecked",
    baseUnitStatus: "unchecked",
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });


  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);
  
  //UseEffect to Fetch Data By ID
  useEffect(() => {
    if (id) {
      fetchUpdateValue();
    }
  }, [id]);
  
  //Fetch Data By ID
  const fetchUpdateValue = async () => {
    try {
      const res = await request(BASEURL, getUom, {
        id: id,
      });
      const v = res.getUom;
      if (v.id == id) {
        const filterbaseUnit = unitData.filter((type) => {
          if (type.unit == v.baseUnit) {
            return type;
          }
        });

        setSelectedData(v);
        setUomData({
          uomName: v.uomName,
          uomAbbreviation: v.uomAbbreviation,
          decimalPlaces: v.decimalPlaces,
          baseUnitValue: v.baseUnitValue,

          baseUnit: {
            value: v.baseUnit,
            label: v.baseUnit,
          },
          status: v.status,

          uomNameStatus: v.uomName ? "success" : "unchecked",
          uomAbbreviationStatus: v.uomAbbreviation ? "success" : "unchecked",

          decimalPlacesStatus: v.decimalPlaces ? "success" : "unchecked",
          baseUnitValueStatus:  "success" ,
          baseUnitStatus: v.baseUnit ? "success" : "unchecked",

        });
      }
      // });
    } catch (err) {
      console.error("Couldnt' fetch Data: ",err.message);
    }
  };

  //Submit Validation
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      uomData.uomNameStatus === "success" &&
      uomData.uomAbbreviationStatus === "success" &&
    uomData.decimalPlacesStatus === "success" &&
      (uomData.baseUnitStatus === "unchecked" ||
        uomData.baseUnitStatus === "success") &&
      (uomData.baseUnitValueStatus === "unchecked" ||
        uomData.baseUnitValueStatus === "success")
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  //Create Mutation
  const handleAddUomData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setCirleLoading(true);
  
        try {
          const response = await request(BASEURL, AddUomMutation, {
            user: currentUser?.id,
            uomName: uomData.uomName,
            uomAbbreviation: uomData.uomAbbreviation,
            decimalPlaces: uomData.decimalPlaces,
            baseUnit: uomData.baseUnit?.label || "",
            baseUnitValue: uomData.baseUnitValue || 0,
            status: uomData.status,
          });
  
          setConfirmationDialog({ ...confirmationDialog, open: false });
          setSuccessStatus(true);
          setSucessTitle("UOM Created");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/uom");
          }, 1000);
        } catch (error) {
         
          const errorMessage =
            error?.response?.errors?.[0]?.message 
          console.error("Error:", errorMessage);
  
          setConfirmationDialog({ ...confirmationDialog, open: false });
          setErrorStatus(true);
          setErrormessage(errorMessage);
  
          setTimeout(() => {
            setErrorStatus(false);
          }, 1000);
        } finally {
          setCirleLoading(false);
        }
      },
      onCancel: () => {
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
    });
  };
  
  //Update Mutation
  const handleEditUomData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Edit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        const values = {
          uomName: uomData.uomName,
          uomAbbreviation: uomData.uomAbbreviation,
          decimalPlaces: uomData.decimalPlaces,
          baseUnitValue: uomData.baseUnitValue,
          baseUnit:uomData.baseUnit?.label,
          status: uomData.status,
        };
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const {updateStatus,errormessage} = await updateUomService(values, id);
        setCirleLoading(false);
        if (updateStatus) {
          setSuccessStatus(true);
          setSucessTitle("UOM Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/uom");
          }, 1000);
        } else {
          setErrorStatus(true);
          setErrormessage(errormessage)
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Delete Mutation
  const handleDeleteUom = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your detail.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setPendingLoading(true);
        const delteStatus = await delteUomService(id);
        if (delteStatus) {
          setSuccessStatus(true);
          setSucessTitle("UOM Deleted");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/uom");
          }, 1000);
        } else if (!delteStatus) {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 1000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Cancel Function
  const handleCancelUomData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        navigate("/uom");
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

    //Discard Function
    const handleDiscardButton = () => {
      setTogglePage({
        view: true,
        edit: false,
      });
      setUomData({
        uomName: selectedData.uomName,
        uomAbbreviation: selectedData.uomAbbreviation,
        decimalPlaces: selectedData.decimalPlaces,
        baseUnitValue: selectedData.baseUnitValue,
       
        status: selectedData.status,
        baseUnit: {
          value: selectedData.baseUnit,
          label: selectedData.baseUnit,
        },
        uomNameStatus: "success",
        uomAbbreviationStatus: "success",
  
        decimalPlacesStatus: "success",
        baseUnitValueStatus: "success",
        baseUnitStatus: "success",
      });
    };
  
    //Handle Change
    const handleUomDataChange = (event, selectEvent) => {
      let uomState = { ...uomData };
      if (event?.target === undefined && selectEvent) {
        switch (selectEvent.name) {
          case "baseUnit":
            {
              const lengthRegex = new RegExp("^[A-Za-z0-9]");
              if (lengthRegex.test(event?.label) === true) {
                uomState[selectEvent.name + "Status"] =
                  event?.label === undefined ? "unchecked" : "success";
              } else {
                uomState[selectEvent.name + "Status"] =
                  selectEvent.value === "" ? "unchecked" : "error";
              }
            }
            break;
        }
        uomState[selectEvent.name] = event;
      } else if (event) {
        switch (event.target.name) {
          case "uomName":
            {
              const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,10})$");
              if (alphaNLenghthRegex.test(event.target.value?.trim())) {
                uomState[event.target.name + "Status"] = "success";
              } else {
                uomState[event.target.name + "Status"] =
                  event.target.value === "" ? "unchecked" : "error";
              }
            }
            break;
          case "uomAbbreviation":
            {
              const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
              if (alphaNLenghthRegex.test(event.target.value?.trim())) {
                uomState[event.target.name + "Status"] = "success";
              } else {
                uomState[event.target.name + "Status"] =
                  event.target.value === "" ? "unchecked" : "error";
              }
            }
            break;
  
          case "decimalPlaces": {
            const numericRegex = new RegExp("^\\d*(\\.\\d{1,4})?$");
            const inputValue = event.target.value?.trim();
  
            if (inputValue && !numericRegex.test(inputValue)) {
              uomState[event.target.name + "Status"] = "error";
              uomState[event.target.name + "ErrorMessage"] =
                "Invalid input: Alphabets are not allowed.";
            } else if (inputValue && parseFloat(inputValue) > 5.0) {
              uomState[event.target.name + "Status"] = "error";
              uomState[event.target.name + "ErrorMessage"] =
                "Invalid input: Number cannot exceed 5.0.";
            } else if (inputValue) {
              uomState[event.target.name + "Status"] = "success";
              uomState[event.target.name + "ErrorMessage"] = "";
            } else {
              uomState[event.target.name + "Status"] = "";
              uomState[event.target.name + "ErrorMessage"] = "";
            }
            break;
          }
  
          case "baseUnitValue":
            {
              const alphaNLenghthRegex = new RegExp("^([0-9.]{1,6})$");
              if (alphaNLenghthRegex.test(event.target.value?.trim())) {
                uomState[event.target.name + "Status"] = "success";
              } else {
                uomState[event.target.name + "Status"] =
                  event.target.value === "" ? "unchecked" : "error";
              }
            }
            break;
        }
        uomState[event.target.name] = event.target.value;
      }
  
      setUomData(uomState);
    };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Unit Of Measure Details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                    size="small"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={handleDeleteUom}
                      startIcon={<DeleteIcon />}
                    >
                      delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ) :togglePage.edit === true? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Edit Unit Of Measurement Details
                    </MaterialTypography>
                  
                  </Stack>
                  <MaterialButton
                      variant="gradient"
                      size="small"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                </Stack>
              )
              
              : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Add Unit Of Measure Details
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
             <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
             <MaterialTypography
             sx={{color:'#460058',fontFamily:'Aptos'}}
               component="label"
               variant="body2"
               fontWeight="700"
             >
               Unit Of Measure Information
             </MaterialTypography>
           </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    UOM Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="uomName"
                  size="small"
                  placeholder="Enter UOM Name"
                  value={uomData.uomName}
                  onChange={handleUomDataChange}
                  error={uomData.uomNameStatus === "error" ? true : false}
                  success={uomData.uomNameStatus === "success" ? true : false}
                  disabled={togglePage?.view === true ? true : false}
                />
                {uomData.uomNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Uom Name should be maximum 10 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    UOM Abbreviation <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="uomAbbreviation"
                  size="small"
                  placeholder="Enter UOM Abbreviation"
                  value={uomData.uomAbbreviation}
                  onChange={handleUomDataChange}
                  error={
                    uomData.uomAbbreviationStatus === "error" ? true : false
                  }
                  success={
                    uomData.uomAbbreviationStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {uomData.uomAbbreviationStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Uom Abbreviation should be maximum 30 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Decimal Places <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="decimalPlaces"
                  placeholder="Enter Decimal Places"
                  size="small"
                  value={uomData.decimalPlaces}
                  onChange={handleUomDataChange}
                  error={uomData.decimalPlacesStatus === "error"}
                  success={uomData.decimalPlacesStatus === "success"}
                  disabled={togglePage?.view === true}
                />
                {uomData.decimalPlacesStatus === "error" &&
                  uomData.decimalPlacesErrorMessage && (
                    <FormControl error>
                      <FormHelperText>
                        {uomData.decimalPlacesErrorMessage}
                      </FormHelperText>
                    </FormControl>
                  )}
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Base Unit
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="baseUnit"
                  size="small"
                  value={uomData.baseUnit}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleUomDataChange} //selectedValue, event
                  options={unitData?.map((item) => {
                    return {
                      value: item?.value,
                      label: item?.label,
                    };
                  })}
                  error={uomData.baseUnitStatus === "error" ? true : false}
                  success={uomData.baseUnitStatus === "success" ? true : false}
                  isDisabled={togglePage?.view === true ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Base Unit Value
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="baseUnitValue"
                  size="small"
                  placeholder="Enter Base Unit Value"
                  value={uomData.baseUnitValue}
                  onChange={handleUomDataChange}
                  error={uomData.baseUnitValueStatus === "error" ? true : false}
                  success={
                    uomData.baseUnitValueStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {uomData.baseUnitValueStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Baseunit value should be maximum 6 digit long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              {/* <Grid size={{ xs: 12, sm: 2 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Round Off
                  </MaterialTypography>
                </MaterialBox>
                <Box>
                  <Switch
                    size="medium"
                    checked={uomData.status}
                    onChange={() =>
                      setUomData({ ...uomData, status: !uomData.status })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                    disabled={togglePage?.view === true ? true : false}
                  />
                </Box>
              </Grid> */}
              <Grid size={{ xs: 12, sm: 2 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Status
                  </MaterialTypography>
                </MaterialBox>
                <Box>
                  <Switch
                    size="medium"
                    checked={uomData.status}
                    onChange={() =>
                      setUomData({ ...uomData, status: !uomData.status })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                    disabled={togglePage?.view === true ? true : false}
                  />
                </Box>
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
            display="flex"
            mt={3}
            justifyContent="center"
            alignItems="center"
          >
            {togglePage.edit === true ? (
              <>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  sx={{ m: 1 }}
                  onClick={handleDiscardButton}
                >
                  Discard
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 1 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  disabled={!checkAllFields()}
                  onClick={handleEditUomData}
                >
                  Update
                </MaterialButton>
              </>
            ) : togglePage.view === false && togglePage.edit === false ? (
              <>
                <MaterialButton
                  sx={{ m: 1 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  disabled={!checkAllFields()}
                  onClick={handleAddUomData}
                >
                  Submit
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 1 }}
                  variant="gradient"
                  size="small"
                  color="dark"
                  onClick={handleCancelUomData}
                >
                  Cancel
                </MaterialButton>
              </>
            ) : null}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
